export default __webpack_public_path__ + "static/media/2.dd6063f6.png";